import { ApiParams, prepareBaseListApiParams } from '@/api/helpers/apiHelpers';
import { getCustomerPortalLinkApi } from '@/api/v1/billing/getCustomerPortalLinkApi';
import { getSinglePaymentInvoicesApi } from '@/api/v1/billing/getSinglePaymentInvoicesApi';
import { getInternalOrganizationBillingDetailsApi } from '@/api/v1/organization/internal/getInternalOrganizationBillingDetailsApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { retrySubscriptionPaymentApi } from '@/api/v1/billing/retrySubscriptionPaymentApi';

export const getCustomerPortalLink = async () => {
  try {
    const response = await getCustomerPortalLinkApi();

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const getInternalOrganizationBillingDetails = async () => {
  try {
    const response = await getInternalOrganizationBillingDetailsApi();

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const getSinglePaymentInvoices = async (params: ApiParams) => {
  const apiParams = prepareBaseListApiParams(params);

  try {
    const response = await getSinglePaymentInvoicesApi(apiParams);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const retrySubscriptionPayment = async () => {
  try {
    const response = await retrySubscriptionPaymentApi();

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
